export default {
  tree: {
    background: "red",
    base: {
      listStyle: "none",
      backgroundColor: "#fbfafa",
      margin: 0,
      padding: 0,
      height: "100%",
      width: "100%",
    },
    node: {
      base: {
        position: "relative",
      },
      link: {
        cursor: "pointer",
        position: "relative",
        padding: "0px 5px",
        borderRadius: "5px",
        alignItems: "center",
        display: "flex",
      },
      activeLink: {
        color: "#2E71FC",
      },
      toggle: {
        base: {
          position: "relative",
          display: "inline-flex",
          verticalAlign: "top",
          marginLeft: "2px",
          height: "24px",
          width: "24px",
          justifyContent: "center",
          alignItems: "center",
        },
        wrapper: {},
        height: 14,
        width: 14,
        arrow: {
          fill: "#9DA5AB",
          strokeWidth: 0,
        },
      },
      header: {
        base: {
          display: "inline-block",
          position: "relative",
          top: "2px",
          //   verticalAlign: "top",
          // color: '#9DA5AB'
        },
        connector: {
          width: "2px",
          height: "12px",
          borderLeft: "solid 2px black",
          borderBottom: "solid 2px black",
          position: "absolute",
          top: "0px",
          left: "-21px",
        },
        title: {},
      },
      subtree: {
        listStyle: "none",
        paddingRight: "14px",
      },
      loading: {
        color: "#E2C089",
      },
    },
  },
};
